import React, { lazy } from 'react';
import { Outlet } from 'react-router-dom';
import { ProtectedRoute } from '@components';

const FeedbackList = lazy(() => import('./list'));
const FeedbackCreate = lazy(() => import('./create'));

export default {
  path: 'feedback',
  element: <Outlet />,
  children: [
    {
      index: true,
      element: <ProtectedRoute title="投诉反馈" component={<FeedbackList />} />,
    },
    {
      path: 'create',
      element: <ProtectedRoute title="提交反馈" component={<FeedbackCreate />} />,
    },
  ],
};
